import React from 'react';
import { Outlet} from 'react-router-dom';


const Factory = () => {

  const App = require( '../../../app' ).default;

  return (
    <App.Data.Identity model={App.model} >
      <Outlet />
    </App.Data.Identity>
  );
};

export default Factory;
